import React, { memo } from 'react';
import AntdTooltip, { TooltipProps } from 'antd/lib/tooltip';

export const Tooltip = memo<TooltipProps>(({ children, ...props }) => {
  return <AntdTooltip {...props}>{children}</AntdTooltip>;
});
